<template>
	<v-snackbar
		v-if="count"
		:key="current.dir"
		v-model="value"
		:color="current.color || defaults.color"
		:timeout="current.timeout || defaults.timeout"
		:dir="current.dir || defaults.dir"
		@click.native="value = false"
	>
		<v-row no-gutters>
			<v-col class="text-start" :cols="count > 1 ? 10 : 12">{{ current.message }}</v-col>
			<v-col class="text-end" cols="2">
				<div v-if="count > 1">(+{{ (count - 1) }})</div>
			</v-col>
		</v-row>
	</v-snackbar>
</template>

<script>
export default {
	props: {
		notifier: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			defaults: {
				timeout: 6000, // 6 seconds
				color: "primary",
				dir: this.$vuetify.rtl ? "rtl" : "ltr"
			},

			value: false,
			notificationStack: []
		};
	},
	computed: {
		count() {
			return this.notificationStack.length;
		},
		current() {
			return this.notificationStack[0];
		}
	},
	watch: {
		notifier(newNotification) {
			this.notificationStack.push(newNotification);
			this.value = true;
		},
		value(newValue) {
			if (newValue == false && this.count != 0) {
				setTimeout(() => {
					this.notificationStack.shift();
					this.value = true;
				}, 100);
			}
		}
	}
};
</script>